import {
    GET_HOME,
    GET_HOME_SUCCESS,
    GET_HOME_FAILURE,
    UPDATE_HOME_STATUS,
    UPDATE_HOME_STATUS_SUCCESS,
    UPDATE_HOME_STATUS_FAILURE,
    UPDATE_HOME_ORDER_STATUS,
    UPDATE_HOME_ORDER_STATUS_SUCCESS,
    UPDATE_HOME_ORDER_STATUS_FAILURE,
    ADD_HOME,
    ADD_HOME_SUCCESS,
    ADD_HOME_FAILURE,
    EDIT_HOME,
    EDIT_HOME_SUCCESS,
    EDIT_HOME_FAILURE,
    DELETE_HOME,
    DELETE_HOME_SUCCESS,
    DELETE_HOME_FAILURE
} from "../Constants";

const init = {
    data: {},
    edit_data: {},
};

const HomeReducer = (state = init, action) => {
    switch (action.type) {
        case GET_HOME:
            return { ...state, loading: true };
        case GET_HOME_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_HOME_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case UPDATE_HOME_STATUS:
            return { ...state, loading: true };
        case UPDATE_HOME_STATUS_SUCCESS:
            return { ...state, loading: false, status_data: action.payload };
        case UPDATE_HOME_STATUS_FAILURE:
            return { ...state, loading: false, status_data: action.payload };
        case UPDATE_HOME_ORDER_STATUS:
            return { ...state, loading: true };
        case UPDATE_HOME_ORDER_STATUS_SUCCESS:
            return { ...state, loading: false, update_order_data: action.payload };
        case UPDATE_HOME_ORDER_STATUS_FAILURE:
            return { ...state, loading: false, update_order_data: action.payload };
        case ADD_HOME:
            return { ...state, loading: true };
        case ADD_HOME_SUCCESS:
            return { ...state, loading: false, add_data: action.payload };
        case ADD_HOME_FAILURE:
            return { ...state, loading: false, add_data: action.payload };
        case EDIT_HOME:
            return { ...state, loading: true };
        case EDIT_HOME_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_HOME_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        case DELETE_HOME:
            return { ...state, loading: true };
        case DELETE_HOME_SUCCESS:
            return { ...state, loading: false, delete_data: action.payload };
        case DELETE_HOME_FAILURE:
            return { ...state, loading: false, delete_data: action.payload };
        default:
            return state;
    }
};

export default HomeReducer;